interface InvestmentLevelCardProps {
  title: string;
  range: string;
  features: string[];
  isSelected: boolean;
  onClick: () => void;
}

export default function InvestmentLevelCard({
  title,
  range,
  features,
  isSelected,
  onClick,
}: InvestmentLevelCardProps) {
  return (
    <button
      onClick={onClick}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-300 text-left ${
        isSelected
          ? 'border-accent bg-accent/5 shadow-lg'
          : 'border-border hover:border-accent/50 hover:shadow-md'
      }`}
    >
      <h3 className="text-lg font-heading font-semibold text-foreground mb-1">
        {title}
      </h3>
      <p className="text-2xl font-heading font-bold text-accent mb-4">{range}</p>
      <ul className="space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start space-x-2 text-sm text-muted-foreground">
            <span className="text-accent mt-0.5">✓</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </button>
  );
}